import CurrencyFormat from "react-currency-format";
import type { V2ProjectResource } from "@generated";

export type ChangeOrderSummary = NonNullable<
  V2ProjectResource["attributes"]["change-order-summary"]
>;

interface Props {
  summary: ChangeOrderSummary;
  currency: string;
}

const Money = ({ value, prefix }: { value: number; prefix: string }) => (
  <CurrencyFormat
    displayType="text"
    prefix={prefix}
    isNumericString
    thousandSeparator
    value={value.toFixed(2)}
  />
);

// The parent's revenue as signed, the counted change-order delta, and the
// two combined. The API computes revenue_including_change_orders as the
// parent's own (cached) revenue plus delta_revenue, so subtracting the delta
// recovers "as signed" on the same basis as the other two figures.
const SummaryInfo = ({ summary, currency }: Props) => {
  const including = Number(summary.revenue_including_change_orders ?? 0);
  const delta = Number(summary.delta_revenue ?? 0);
  const asSigned = including - delta;

  return (
    <div
      className="d-flex flex-wrap align-items-center"
      style={{ gap: "1.5rem" }}
      data-testid="change-order-summary"
    >
      <span>
        <strong>As signed: </strong>
        <Money value={asSigned} prefix={currency} />
      </span>
      <span>
        <strong>Change orders: </strong>
        <Money value={delta} prefix={`+${currency}`} />{" "}
        <span className="text-muted">
          ({summary.counted_count ?? 0} of {summary.count ?? 0} counting)
        </span>
      </span>
      <span>
        <strong>Including change orders: </strong>
        <Money value={including} prefix={currency} />
      </span>
    </div>
  );
};

export default SummaryInfo;
